/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccE2eFixtureResetDocument
 */
export interface PccE2eFixtureResetDocument {
    /**
     * 
     * @type {string}
     * @memberof PccE2eFixtureResetDocument
     */
    relation_type: PccE2eFixtureResetDocumentRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PccE2eFixtureResetDocument
     */
    relation_id: string;
}


/**
 * @export
 */
export const PccE2eFixtureResetDocumentRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type PccE2eFixtureResetDocumentRelationTypeEnum = typeof PccE2eFixtureResetDocumentRelationTypeEnum[keyof typeof PccE2eFixtureResetDocumentRelationTypeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetDocument interface.
 */
export function instanceOfPccE2eFixtureResetDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "relation_type" in value;
    isInstance = isInstance && "relation_id" in value;

    return isInstance;
}

export function PccE2eFixtureResetDocumentFromJSON(json: any): PccE2eFixtureResetDocument {
    return PccE2eFixtureResetDocumentFromJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relation_type': json['relation_type'],
        'relation_id': json['relation_id'],
    };
}

export function PccE2eFixtureResetDocumentToJSON(value?: PccE2eFixtureResetDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relation_type': value.relation_type,
        'relation_id': value.relation_id,
    };
}

